const getFullStreetAddress = ({
  street,
  houseNumber,
  apartmentNumber,
  locality,
}: {
  street?: string;
  houseNumber?: string;
  apartmentNumber?: string;
  locality?: string;
}): string =>
  `${street || locality || ''}${houseNumber ? ` ${houseNumber}${apartmentNumber ? `/${apartmentNumber}` : ''}` : ''}`;

export default getFullStreetAddress;
